import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'

@observer
class AccessRights extends PureComponent {
    state = {
        canAccess: false,
    }

    componentDidMount() {
        const {
            store,
            role,
            deniedRedirect,
            customRule,
        } = this.props
        const { roles } = store.tokenData
        let canAccess = true
        console.log(`AccessRights ${role} ${deniedRedirect} ${roles}`)
        if (role && !roles.match(new RegExp(role, 'gi'))) {
            canAccess = false
        }
        if (customRule && typeof customRule === 'function') {
            const customAccess = customRule(deniedRedirect, role)
            if (customAccess === true || customAccess === false) {
                canAccess = customAccess
            }
        }

        if (!canAccess) {
            window.location.href = deniedRedirect
        }

        this.setState({
            canAccess,
        })
    }

    render() {
        const { children } = this.props
        return (
            this.state.canAccess ? [children] : <div></div>
        )
    }
}

export default AccessRights
